//
// Input Money Controller
//
// Restricts input to money
//
import { Controller } from '@hotwired/stimulus'
import AutoNumeric from 'autonumeric'

export default class extends Controller {
  static values = {
    config: Object,
  }

  initialize() {
    this.configValue = {}
  }
  connect() {
    // Check if AutoNumeric already exists on this element
    const existingInstance = AutoNumeric.getAutoNumericElement(this.element)
    if (existingInstance) {
      // Use the existing instance instead of creating a new one
      this.inputMoney = existingInstance
    } else {
      // Create new instance only if one doesn't exist
      this.inputMoney = new AutoNumeric(this.element, {
        digitGroupSeparator: '',
        leadingZero: 'deny',
        modifyValueOnWheel: false,
        minimumValue: 0,
        emptyInputBehavior: 'null',
        watchExternalChanges: true,
        ...this.configValue,
      })
    }
  }

  disconnect() {
    // Only remove if we have a reference AND the instance still exists on the element
    if (this.inputMoney && AutoNumeric.getAutoNumericElement(this.element)) {
      try {
        this.inputMoney.remove()
        this.inputMoney = null
      } catch (error) {
        // Silently handle cleanup errors
        console.warn('AutoNumeric cleanup error:', error)
      }
    }
  }
}
